import { Col, Row, Spin } from 'antd';
import { StyledContainer } from '../../../components/container/styles';
import { TextLarge } from '../../../components/text';
import { useGetRegEditList } from './hooks/useGetRegEditList';
import { CardTheme } from '../../../components/card';
import { RenderForm } from '../../../components/forms';
import { ButtonTheme } from '../../../components/buttons';
import { FORM_CUSTOMER_DATA, FORM_PRODUCT_DATA } from './form';
import { ContainerButton } from '../../../styles/global-style';
import React from 'react';
import { UpDateExpModal } from './modal/UpDateExpModal';

export const RegistrationEdit = () => {
  const {
    control,
    getValues,
    setValue,
    mobileBrandList,
    channelBuyList,
    LoadingWarrantyEdit,
    goBack,
    onEnterBarcodeFunction,
    onEnterWarrantyCode,
    loadingBarcode,
    openExpModal,
    onToggleExpModal,
    dataExp,
    handleSubmit,
    onSubmit,
    loadingEditDataReg,
  } = useGetRegEditList();

  return (
    <Spin spinning={LoadingWarrantyEdit || loadingBarcode || loadingEditDataReg}>
      <StyledContainer>
        <TextLarge text="แก้ไขข้อมูลลงทะเบียนสินค้า" />
        <Row gutter={16}>
          <Col span={14}>
            <CardTheme>
              <TextLarge text="ลูกค้าลงทะเบียนรับประกัน" />
              <RenderForm
                control={control}
                setValue={setValue}
                getValues={getValues}
                forms={FORM_CUSTOMER_DATA()}
              />
              <ContainerButton right>
                <ButtonTheme useFor="EDIT2" title="แก้ไขวันหมดอายุ" onClick={onToggleExpModal} />
                {openExpModal && (
                  <UpDateExpModal
                    open={openExpModal}
                    onToggle={onToggleExpModal}
                    dataExp={dataExp}
                  />
                )}
              </ContainerButton>
            </CardTheme>
          </Col>
          <Col span={10}>
            <CardTheme>
              <TextLarge text="สินค้าลงทะเบียนรับประกัน" />
              <RenderForm
                control={control}
                setValue={setValue}
                getValues={getValues}
                forms={FORM_PRODUCT_DATA({
                  mobileBrandList,
                  channelBuyList,
                  onEnter: onEnterBarcodeFunction,
                  onEnterWarrantyCode,
                  getValues,
                })}
              />
            </CardTheme>
          </Col>
        </Row>
        <Row gutter={16} justify="space-between" align="middle" style={{ marginTop: '2%' }}>
          <Col>
            <ButtonTheme useFor="BACK" title="ย้อนกลับ" onClick={goBack} />
          </Col>
          <Col>
            <ButtonTheme useFor="SUBMIT" onClick={handleSubmit(onSubmit)} />
          </Col>
        </Row>
      </StyledContainer>
    </Spin>
  );
};
